import { Container, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';

export function LoginLayout() {
  return (
    <Stack display="flex" height="100vh" justifyContent="center">
      <Container sx={{ width: { md: '35%', xs: '100%' } }}>
        <Outlet />
      </Container>
    </Stack>
  );
}
